/**
 * @flow
 * */
import RISK_WEEKLY_ACTION_TYPES from './types';

export const fetchWeeks = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_WEEKS,
  payload
});

export const setFetchWeeksSuccess = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_WEEKS_SUCCESS,
  payload
});

export const setFetchWeeksFailure = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_WEEKS_FAILURE,
  payload
});

export const fetchOverview = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_OVERVIEW,
  payload
});

export const setFetchOverviewSuccess = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_OVERVIEW_SUCCESS,
  payload
});

export const setFetchOverviewFailure = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_OVERVIEW_FAILURE,
  payload
});

export const fetchDepartmentDetail = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_DEPARTMENT_DETAIL,
  payload
});

export const setFetchDepartmentDetailSuccess = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_DEPARTMENT_DETAIL_SUCCESS,
  payload
});

export const setFetchDepartmentDetailFailure = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_DEPARTMENT_DETAIL_FAILURE,
  payload
});

export const fetchPartnerCoverage = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_PARTNER_COVERAGE,
  payload
});

export const setFetchPartnerCoverageSuccess = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_PARTNER_COVERAGE_SUCCESS,
  payload
});

export const setFetchPartnerCoverageFailure = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_PARTNER_COVERAGE_FAILURE,
  payload
});

// =====================================================================================
// DISABLED - action creators for the five views the first production release does not ship.
// RMT8993, 2026-09-14; see docs/report_docs/13-live-dashboard-only.md.
// =====================================================================================
// export const fetchGrmt = (payload: Object = {}) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.FETCH_GRMT,
  // payload
// });

// export const setFetchGrmtSuccess = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_GRMT_SUCCESS,
  // payload
// });

// export const setFetchGrmtFailure = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_GRMT_FAILURE,
  // payload
// });

// export const fetchGrmtSettingDetail = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.FETCH_GRMT_SETTING_DETAIL,
  // payload
// });

// export const setFetchGrmtSettingDetailSuccess = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_GRMT_SETTING_DETAIL_SUCCESS,
  // payload
// });

// export const setFetchGrmtSettingDetailFailure = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_GRMT_SETTING_DETAIL_FAILURE,
  // payload
// });

// export const fetchEmployeeAnalytics = (payload: Object = {}) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.FETCH_EMPLOYEE_ANALYTICS,
  // payload
// });

// export const setFetchEmployeeAnalyticsSuccess = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_EMPLOYEE_ANALYTICS_SUCCESS,
  // payload
// });

// export const setFetchEmployeeAnalyticsFailure = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_EMPLOYEE_ANALYTICS_FAILURE,
  // payload
// });

// export const fetchEmployeeDetail = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.FETCH_EMPLOYEE_DETAIL,
  // payload
// });

// export const setFetchEmployeeDetailSuccess = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_EMPLOYEE_DETAIL_SUCCESS,
  // payload
// });

// export const setFetchEmployeeDetailFailure = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_EMPLOYEE_DETAIL_FAILURE,
  // payload
// });

// export const fetchPartnerTrigger = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.FETCH_PARTNER_TRIGGER,
  // payload
// });

// export const setFetchPartnerTriggerSuccess = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_PARTNER_TRIGGER_SUCCESS,
  // payload
// });

// export const setFetchPartnerTriggerFailure = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_PARTNER_TRIGGER_FAILURE,
  // payload
// });

export const fetchCalendar = () => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_CALENDAR
});

export const setFetchCalendarSuccess = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CALENDAR_SUCCESS,
  payload
});

export const setFetchCalendarFailure = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CALENDAR_FAILURE,
  payload
});

export const fetchExploreCube = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_EXPLORE_CUBE,
  payload
});

export const setFetchExploreCubeSuccess = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_EXPLORE_CUBE_SUCCESS,
  payload
});

export const fetchDailyStatistics = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_DAILY_STATISTICS,
  payload
});

export const setFetchDailyStatisticsSuccess = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_DAILY_STATISTICS_SUCCESS,
  payload
});

export const setFetchDailyStatisticsFailure = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_DAILY_STATISTICS_FAILURE,
  payload
});

export const setFetchExploreCubeFailure = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_EXPLORE_CUBE_FAILURE,
  payload
});

// export const fetchInsights = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.FETCH_INSIGHTS,
  // payload
// });

// export const setFetchInsightsSuccess = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_INSIGHTS_SUCCESS,
  // payload
// });

// export const setFetchInsightsFailure = (payload: Object) => ({
  // type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_INSIGHTS_FAILURE,
  // payload
// });

export const cancelSdkCall = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.CANCEL_SDK_CALL,
  payload
});

export const setFilter = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FILTER,
  payload
});

export const clearState = () => ({
  type: RISK_WEEKLY_ACTION_TYPES.CLEAR_STATE
});

// ---- Configuration management ----

export const fetchConfigOverview = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_CONFIG_OVERVIEW,
  payload
});

export const setFetchConfigOverviewSuccess = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CONFIG_OVERVIEW_SUCCESS,
  payload
});

export const setFetchConfigOverviewFailure = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CONFIG_OVERVIEW_FAILURE,
  payload
});

export const fetchConfigPage = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_CONFIG_PAGE,
  payload
});

export const setFetchConfigPageSuccess = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CONFIG_PAGE_SUCCESS,
  payload
});

export const setFetchConfigPageFailure = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CONFIG_PAGE_FAILURE,
  payload
});

export const fetchConfigUnmapped = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_CONFIG_UNMAPPED,
  payload
});

export const setFetchConfigUnmappedSuccess = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CONFIG_UNMAPPED_SUCCESS,
  payload
});

export const setFetchConfigUnmappedFailure = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CONFIG_UNMAPPED_FAILURE,
  payload
});

export const saveConfigRow = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SAVE_CONFIG_ROW,
  payload
});

export const setSaveConfigRowSuccess = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_SAVE_CONFIG_ROW_SUCCESS,
  payload
});

export const setSaveConfigRowFailure = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_SAVE_CONFIG_ROW_FAILURE,
  payload
});

export const deleteConfigRow = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.DELETE_CONFIG_ROW,
  payload
});

export const setDeleteConfigRowSuccess = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_DELETE_CONFIG_ROW_SUCCESS,
  payload
});

export const setDeleteConfigRowFailure = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_DELETE_CONFIG_ROW_FAILURE,
  payload
});

export const clearConfigSaveResult = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.CLEAR_CONFIG_SAVE_RESULT,
  payload
});

export const fetchConfigHistory = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.FETCH_CONFIG_HISTORY,
  payload
});

export const setFetchConfigHistorySuccess = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CONFIG_HISTORY_SUCCESS,
  payload
});

export const setFetchConfigHistoryFailure = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_FETCH_CONFIG_HISTORY_FAILURE,
  payload
});


/**
 * clearServerCache — drops the backend's in-memory report build.
 *
 * Seconds, not minutes: the facts stay in the warehouse and only the classification over them is
 * redone. It used to take an `includeWeekCache` flag that also deleted on-disk week files; those
 * went with the warehouse.
 *
 * @param {Object} payload - { reloadOnSuccess }
 * @returns {Object} - action
 */
export const clearServerCache = (payload: Object = {}) => ({
  type: RISK_WEEKLY_ACTION_TYPES.CLEAR_SERVER_CACHE,
  payload
});

export const setClearServerCacheSuccess = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_CLEAR_SERVER_CACHE_SUCCESS,
  payload
});

export const setClearServerCacheFailure = (payload: Object) => ({
  type: RISK_WEEKLY_ACTION_TYPES.SET_CLEAR_SERVER_CACHE_FAILURE,
  payload
});
